var map = {
	"./Commands.vue": [
		"af8b",
		"chunk-5a512847"
	],
	"./Forbidden.vue": [
		"dc82",
		"chunk-6e41bbe9"
	],
	"./Home.vue": [
		"bb51",
		"chunk-0e466406"
	],
	"./Imprint.vue": [
		"5a7f",
		"chunk-50c1134d"
	],
	"./Invite.vue": [
		"0c50",
		"chunk-303b9e6c"
	],
	"./Languages.vue": [
		"6759",
		"chunk-37e8511e"
	],
	"./PageNotFound.vue": [
		"a5b5",
		"chunk-e854e30e"
	],
	"./Server.vue": [
		"1d74",
		"chunk-6309585d"
	],
	"./Social.vue": [
		"d328",
		"chunk-6deab703"
	],
	"./Stats.vue": [
		"ed93",
		"chunk-117b4a9a"
	],
	"./Todo.vue": [
		"a3b3",
		"chunk-fc59be02"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;